<div class="item cn-up-down">
	<i class="icon audio-mes" data-config="audio-message">
		<playback-ico></playback-ico>
		<span class="counter"><span>{{ node._id_ + 1 }}</span></span>
	</i>
	<div class="name">Аудио-сообщение</div>
</div>
<div *ngIf="node != null && node.next != null" schema-node [node]="node.next"></div>